export const GET_BILLING_DETAILS_LIST = 'GET_BILLING_DETAILS_LIST';
export const GET_BILLING_DETAILS_LIST_ERROR = 'GET_BILLING_DETAILS_LIST_ERROR';

export const GET_BILLING_REPORTS_LIST = 'GET_BILLING_REPORTS_LIST';
export const GET_BILLING_REPORTS_LIST_ERROR = 'GET_BILLING_REPORTS_LIST_ERROR';

export const GET_BILLING_REPORTS_DETAILS = 'GET_BILLING_REPORTS_DETAILS';
export const GET_BILLING_REPORTS_DETAILS_ERROR =
  'GET_BILLING_REPORTS_DETAILS_ERROR';

export const BILLING_REPORT_LOAD = 'BILLING_REPORT_LOAD';

export const STUDENT_DATA_LOAD = 'STUDENT_DATA_LOAD';

export const BILLING_CHECKALL = 'BILLING_CHECKALL';
export const UPDATE_BILLING_DATA_CHECK = 'UPDATE_BILLING_DATA_CHECK';

export const CLEAR_DETAIL_REPORT = 'CLEAR_DETAIL_REPORT';
export const CLEAR_LIST_REPORT = 'CLEAR_LIST_REPORT';



// WEBPACK FOOTER //
// ./src/pages/billingaccount/state/types.js